/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svc_Agents_Art_1_DetailInputs */

const en_svc_agents_art_1_detail = /** @type {(inputs: Svc_Agents_Art_1_DetailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Company and request extracted`)
};

const lv_svc_agents_art_1_detail = /** @type {(inputs: Svc_Agents_Art_1_DetailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Uzņēmums un pieprasījums nolasīti`)
};

/**
* | output |
* | --- |
* | "Company and request extracted" |
*
* @param {Svc_Agents_Art_1_DetailInputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const svc_agents_art_1_detail = /** @type {((inputs?: Svc_Agents_Art_1_DetailInputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svc_Agents_Art_1_DetailInputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_svc_agents_art_1_detail(inputs)
	return en_svc_agents_art_1_detail(inputs)
});